const baseURL = 'https://inversionesanahi.compuservictecnologia.com';

export default baseURL;
